<div class="main-wrapper-section">
  <div class="common-header">
    <h3>General</h3>
  </div>
  <div class="card-section">
    <div class="card-panel">
      <p class="heading-text">The following fields are used to customize each club.</p>

      <form [formGroup]="clubConfigForm" (ngSubmit)="onSubmitClubConfigForm()">
          <div class="flex-form">
              <div class="form-group">
                  <label>Club Name</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubName')">PH_CMClubName</div>
                  <input class="form-control" formControlName="clubName" maxlength="50" />
                  <div *ngIf="clubConfigForm.controls.clubName.errors && (clubConfigForm.controls.clubName.touched || clubConfigForm.controls.clubName.dirty)">
                      <div class="login-error" *ngIf="clubConfigForm.controls.clubName.errors.required">Club name is required. </div>
                  </div>
              </div>
              <div class="form-group">
                  <label>Team</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubTeam')">PH_CMClubTeam</div>
                  <kendo-combobox *ngIf="userRole >= 3 || slurpyUserId > 0" class="form-control min-width300" [data]="teamFilterDD"
                                  [valuePrimitive]="true"
                                  textField="display"
                                  [kendoDropDownFilter]="filterSettings"
                                  [filterable]="true"
                                  formControlName="teamCode"
                                  (valueChange)="onChangeTeamCode($event)"
                                  valueField="teamCode">
                  </kendo-combobox>
                  <div *ngIf="userRole >= 3 || slurpyUserId > 0">
                      <div *ngIf="clubConfigForm.controls.teamCode.errors && (clubConfigForm.controls.teamCode.touched || clubConfigForm.controls.teamCode.dirty)">
                          <div class="login-error" *ngIf="clubConfigForm.controls.teamCode.errors.required">Team is required.</div>
                      </div>
                  </div>
                  <p *ngIf="userRole < 3">{{curTeam?.display}}</p>
              </div>
              <div class="form-group" *ngIf="userRole >= 3 || slurpyUserId > 0">
                  <label>Owner</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubUser')">PH_CMClubUser</div>
                  <kendo-combobox class="form-control min-width300" [data]="userList"
                                  [valuePrimitive]="true"
                                  textField="text"
                                  [kendoDropDownFilter]="filterSettings"
                                  [filterable]="true"
                                  formControlName="ownerUserId"
                                  valueField="value">
                  </kendo-combobox>
                  <!--<p *ngIf="user?.userRole < 3">{{selectedUser?.text}}</p>-->
              </div>
          </div>
          <div class="flex-form">
              <div class="form-group">
                  <label>EIN</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubEIN')">PH_CMClubEIN</div>
                  <input class="form-control" formControlName="clubEIN" maxlength="50" />
              </div>
              <div class="form-group">
                  <label>Region</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubRegion')">PH_CMClubRegion</div>
                  <input class="form-control" formControlName="clubRegion" maxlength="50" />
              </div>
              <div class="form-group">
                  <label>Territory</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubTerritory')">PH_CMClubTerritory</div>
                  <input class="form-control" formControlName="clubTerritory" maxlength="50" />
              </div>
          </div>
          <div class="flex-form">
              <div class="form-group flex-none min-width300">
                  <label>Address</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubAddress')">PH_CMClubAddress</div>
                  <input class="form-control" formControlName="clubAddress" maxlength="50" />
              </div>
              <div class="form-group flex-none min-width300">
                  <label>City</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubCity')">PH_CMClubCity</div>
                  <input class="form-control" formControlName="clubCity" maxlength="50" />
              </div>
              <div class="form-group">
                  <label>State</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubState')">PH_CMClubState</div>
                  <kendo-combobox [data]="stateList"
                                  class="form-control min-width300"
                                  [valuePrimitive]="true"
                                  [kendoDropDownFilter]="filterSettings"
                                  [filterable]="true"
                                  [(ngModel)]="stateCode"
                                  [ngModelOptions]="{standalone: true}"
                                  textField="text"
                                  valueField="value">
                  </kendo-combobox>
              </div>
          </div>
          <div class="flex-form">
              <div class="form-group">
                  <label class="fldtitle">Zip</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubZip')">PH_CMClubZip</div>
                  <input type="text" formControlName="clubZip" maxlength="6" autocomplete="off" value="247001" class="form-control">
              </div>
              <div class="form-group">
                  <label>Country</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubCountry')">PH_CMClubCountry</div>
                  <kendo-combobox [data]="countryDD"
                                  class="form-control min-width300"
                                  [valuePrimitive]="true"
                                  [kendoDropDownFilter]="filterSettings"
                                  [filterable]="true"
                                  textField="text"
                                  [(ngModel)]="countryCode"
                                  [ngModelOptions]="{standalone: true}"
                                  valueField="value"
                                  (valueChange)="onChangeCountry($event)"
                                  placeholder="--Select--">
                  </kendo-combobox>
              </div>
              <div class="form-group">
                  <div class="custom-control custom-switch payment-process-check">
                      <input type="checkbox" class="custom-control-input" id="processorTestMode" formControlName="isContractReview">
                      <label class="custom-control-label custom-control-label-disabled" for="processorTestMode">Enable Contract Review</label>
                  </div>
              </div>
          </div>
          <div class="flex-form">
              <div class="form-group">
                  <label>Custom 1</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubCustom1')">PH_CMClubCustom1</div>
                  <input class="form-control" formControlName="custom1" maxlength="100" />
              </div>
              <div class="form-group">
                  <label>Custom 2</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubCustom2')">PH_CMClubCustom2</div>
                  <input class="form-control" formControlName="custom2" maxlength="100" />
              </div>
              <div class="form-group">
                  <label>Custom 3</label>
                  <div class="clickable m-placeholder" (click)="copyToClip('PH_CMClubCustom3')">PH_CMClubCustom3</div>
                  <input class="form-control" formControlName="custom3" maxlength="100" />
              </div>
          </div>
          <hr />

          <div class="button-group">
              <div class="form-group">
                  <button class="primary-btn" type="submit">Save <i *ngIf="submitted" class="fas fa-spinner fa-spin"></i></button>
              </div>
          </div>
      </form>

    </div>
  </div>
</div>
<!--<div class="loader-body" *ngIf="showSpinner">
  <div class="lds-ripple"><div></div><div></div></div>
</div>-->
